import React, { useEffect, useState } from "react";
import axios from "axios";
import { MyListPayment } from "../../components/";
import { useRequest } from "../../utils";
//locall

const GetSupportPayments = (props) => {
  //   const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [search_text, set_search_text] = useState("");
  const [_status, set_status] = useState(null);
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });
  const [start_date, set_start_date] = useState();
  const [end_date, set_end_date] = useState();

  const [
    GetPayments_error,
    GetPayments_loading,
    GetPayments_data,
    GetPayments_function,
  ] = useRequest({
    method: "post",
    url: "/get_support_payments",
    body: {
      page,
      search_text,
      _status,
      start_date,
      end_date,
    },
  });
  useEffect(() => {
    GetPayments_function().then(() => null);
  }, [page]);

  //   const { cookies } = props.cookies;

  //   useEffect(() => {
  //     axios
  //       .post(
  //         "/shoppingbasket_get_list",
  //         {
  //           page: page,
  //         },
  //         {
  //           headers: {
  //             Authorization: cookies.token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         if (res) {
  //           setData(res.data);
  //         }
  //       });
  //   }, [page, cookies.token]);

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        {GetPayments_data ? (
          <MyListPayment
            data={GetPayments_data.result.docs}
            pages={GetPayments_data.result.totalPages}
            totalDocs={GetPayments_data.result.totalDocs}
            GetPayments_function={GetPayments_function}
            set_search_text={set_search_text}
            search_text={search_text}
            _status={_status}
            set_status={set_status}
            set_start_date={set_start_date}
            start_date={start_date}
            set_end_date={set_end_date}
            end_date={end_date}
            selectedDayRange={selectedDayRange}
            setSelectedDayRange={setSelectedDayRange}
            //   token={cookies.token}
            setPage={setPage}
            page={page}
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetSupportPayments };
